import '../scss/index.scss';
// import 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import DataLoader from './DataLoader';
import Model from './Model';
import EventHandlers from './EventHandlers';
import { RenderPageData, displayWrongUrlMsg } from './RenderData';
import configData from '../config/config.json';
import HandleUrlVars from './HandleUrlVars';
import { getAppLoc } from './Helpers';
import InfoModal from './InfoModal';
import Footer from './Footer';

Model.versionData = VERSION_DATA;
Footer.render();
let appLoc = getAppLoc(configData);
console.log('appLoc:', appLoc);
Model.urls.data = configData[appLoc].dataUrl;
Model.urls.edit = configData[appLoc].editUrl;
Model.urls.player = configData[appLoc].playerUrl;
Model.urls.login = configData[appLoc].playerUrl;
if (sessionStorage.scrollPos) {
  Model.tempUserData.scrollPos = JSON.parse(sessionStorage.scrollPos);
}
// console.log('Model:', JSON.stringify(Model, null, '\t'));
let paramObj = HandleUrlVars();
$('body').removeClass('loading');

let onModelLoaded = function(data) {
  Model.data = data.data;
  Model.projektInfo = data.projektInfo;
  $('.loading').removeClass('loading');
  InfoModal.init();
  RenderPageData($('#coursesContainer'));
  EventHandlers();
};
console.time();
if (paramObj.pOk) {
  Model.parameters.projektId = paramObj.pId;
  DataLoader.load(Model.urls.data + '?pid=' + paramObj.pId, onModelLoaded);
} else {
  displayWrongUrlMsg();
}
